import { useState, useCallback, useEffect } from 'react';
const getStorageKey = (projectId) => `landscope_draft_comments_${projectId}`;
const loadDrafts = (projectId) => {
    try {
        const raw = localStorage.getItem(getStorageKey(projectId));
        if (!raw)
            return [];
        return JSON.parse(raw);
    }
    catch (_a) {
        return [];
    }
};
const saveDrafts = (projectId, drafts) => {
    localStorage.setItem(getStorageKey(projectId), JSON.stringify(drafts));
};
export const draftCommentsStorage = {
    getDrafts: (projectId) => loadDrafts(projectId),
    getDraftsForUnsavedItem: (projectId, unsavedItemId) => {
        return loadDrafts(projectId).filter(d => d.unsavedItemId === unsavedItemId);
    },
    clearDraftsForItem: (projectId, unsavedItemId) => {
        const drafts = loadDrafts(projectId);
        const filtered = drafts.filter(d => d.unsavedItemId !== unsavedItemId);
        saveDrafts(projectId, filtered);
    },
};
let idCounter = 0;
const generateDraftId = () => {
    idCounter++;
    return `draft-${Date.now()}-${idCounter}`;
};
export const useDraftComments = (projectId) => {
    const [drafts, setDrafts] = useState(() => loadDrafts(projectId));
    useEffect(() => {
        setDrafts(loadDrafts(projectId));
    }, [projectId]);
    useEffect(() => {
        saveDrafts(projectId, drafts);
    }, [projectId, drafts]);
    const createDraft = useCallback((data) => {
        const draft = {
            ...data,
            id: generateDraftId(),
            createdAt: Date.now(),
        };
        setDrafts(prev => [draft, ...prev]);
    }, []);
    const deleteDraft = useCallback((draftId) => {
        setDrafts(prev => prev.filter(d => d.id !== draftId));
    }, []);
    const getDraftsForUnsavedItem = useCallback((unsavedItemId) => {
        return drafts.filter(d => d.unsavedItemId === unsavedItemId);
    }, [drafts]);
    const clearDraftsForItem = useCallback((unsavedItemId) => {
        setDrafts(prev => prev.filter(d => d.unsavedItemId !== unsavedItemId));
    }, []);
    return {
        drafts,
        createDraft,
        deleteDraft,
        getDraftsForUnsavedItem,
        clearDraftsForItem,
    };
};
